<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import ImportStudents from "./import-students.vue";
import VyukaForm from "@/components/ll/vyuka-form.vue";
import LessonInstance from "@/components/ll/lesson-instance.vue";
import AdminCreditHistoryModal from "./admin-credit-history-modal.vue";
import OjPagination from "../OjPagination.vue";

export default {
  name: "my_students",
  props: ['btyp', 'admin', 'currentuser'],
  components: {LessonInstance, VyukaForm, ImportStudents, AdminCreditHistoryModal, OjPagination },
  data() {
    return {
      lessons: [],
      companies:[],
      current_lesson: null,
      lector_options: [],
      selectedCompany: null,
      selectedLector: null,
      selectedTypeLesson: null,
      credit_range: '',
      searchQuery: '',
      searchGroupName: '',
      searchDebounceTimer: null,
      zaskok: 'm', // Default to "my lessons"
      activeStatus: '', // Filter for active/inactive status
      // Pagination
      page: 1,
      per: 50,
      total: 0
    };
  },
  mounted() {
    this.loadStudents();
  },
  watch: {
    selectedCompany() { this.page = 1; this.loadStudents(); },
    selectedLector() { this.page = 1; this.loadStudents(); },
    selectedTypeLesson() { this.page = 1; this.loadStudents(); },
    credit_range() { this.page = 1; this.loadStudents(); },
    activeStatus() { this.page = 1; this.loadStudents(); },
    zaskok() { this.page = 1; this.loadStudents(); },
    per() { this.page = 1; this.loadStudents(); }
  },
  methods: {
    handleEditLesson(lesson) {
        this.current_lesson = lesson;
        // Předpokládáme, že máte komponentu pro úpravu lekce
        // Můžete zde otevřít modální okno nebo přesměrovat
      this.$refs.formVyuka.showModal();

    },
    handleNewLessonInstance(lesson) {
      console.log('Attempting to add new lesson instance for lesson', lesson.id, 'Accounting type:', lesson.accounting_type, 'Credit:', lesson.credit, 'Instances count:', lesson.instances_count, 'Instances this month:', lesson.instances_count_this_month);
      // Kontrola accounting limits podle typu systému
      if (lesson.accounting_type === 'credit_based' && (lesson.credit <= 0 || lesson.credit <= lesson.instances_count)) {
        toast.error("Student has no credit!");
        return;
      }
      
      if (lesson.accounting_type === 'lessons_per_month') {
        const currentCount = lesson.instances_count_this_month || 0;
        if (currentCount >= lesson.lessons_per_month) {
          toast.error(`This month's lesson limit has been exceeded (${currentCount}/${lesson.lessons_per_month})`);
          return;
        }
      }
      
      // Pro flexible - vždy povolit
      this.current_lesson = lesson;
      this.$refs.formLessonInstance.showModal();

    },


    loadStudents() {
      const url = '/ll/students/lessons.json';
      axios.get(url, {
        params: {
          btyp: this.btyp,
          company_id: this.selectedCompany,
          lector_id: this.selectedLector,
          lesson_type: this.selectedTypeLesson,
          credit_range: this.credit_range,
          search_query: this.searchQuery,
          group_name: this.searchGroupName,
          zaskok: this.zaskok,
          active_status: this.activeStatus,
          page: this.page,
          per: this.per
        }
      })
          .then(response => {
            this.lessons = response.data.lessons;
            this.companies = response.data.companies;
            this.lector_options = response.data.lectors;
            this.total = response.data.total;
          })
          .catch(error => {
            console.error('Došlo k chybě při načítání lekcí:', error);
          });
    },
    handleSearchInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1;
        this.loadStudents();
      }, 500);
    },
    handleGroupNameInput() {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.page = 1;
        this.loadStudents();
      }, 500);
    },
    handleImportSuccess() {
      this.loadStudents();
    },
    showImportModal() {
      this.$refs.importStudentsComponent.showModal();
    },
    addVyuka() {
      this.current_lesson = {
        students: [],
        lector: null,
        lesson_type: 'one_to_one',
        language_level: '',
        preferred_time: '',
        preferred_times: [],
        minutes: 0,
        lessons_per_month: 0,
        credit: 0,
        change_credit:0
      };
      this.$refs.formVyuka.showModal();
    },
    handleSaveLesson(lesson) {
      this.loadStudents();
    },
    pageChanged(p) {
      this.page = p;
      this.loadStudents();
    },
    showCreditHistory(lesson) {
      this.$refs.creditHistoryModal.open(lesson.id);
    },
    handleDeleteLesson(lesson) {
      const studentNames = lesson.students.map(s => `${s.name} ${s.surname}`).join(', ');
      const confirmMessage = `Are you sure you want to delete this lesson?\n\nStudents: ${studentNames}\nLesson type: ${lesson.lesson_type_name}\n\nThis action cannot be undone and will remove all lesson history, instances, and credit transfers.`;

      if (confirm(confirmMessage)) {
        axios.delete(`/ll/students/lessons/${lesson.id}`)
          .then(() => {
            toast.success('Lesson deleted successfully');
            this.loadStudents();
          })
          .catch(error => {
            console.error('Error deleting lesson:', error);
            toast.error('Error deleting lesson');
          });
      }
    },
    
    getPreferredTimeBadgeClass(preferredTimeKey) {
      const badgeClasses = {
        'weekday_morning': 'badge-warning',     // Yellow
        'weekday_afternoon': 'badge-info',      // Blue
        'weekday_evening': 'badge-purple',      // Purple (custom)
        'weekend': 'badge-success'              // Green
      };
      return badgeClasses[preferredTimeKey] || 'badge-secondary';
    },

    // Kontrola, zda lze přidat novou lekci
    canAddLessonInstance(lesson) {
      // Credit-based systém
      if (lesson.accounting_type === 'credit_based') {

        //console.log('Checking credit for lesson', lesson.id, 'Credit:', lesson.credit, lesson);


        return lesson.credit > lesson.instances_count;
      }
      
      // Lessons per month systém
      if (lesson.accounting_type === 'lessons_per_month') {
        const currentCount = lesson.instances_count_this_month || 0;
        return currentCount < lesson.lessons_per_month;
      }
      
      // Flexible - vždy povolit
      return true;
    },

    // Vrátí zprávu, proč nelze přidat lekci
    getLimitMessage(lesson) {
      if (lesson.accounting_type === 'credit_based' && lesson.credit <= 0) {
        return 'Student has no credit!';
      }
      
      if (lesson.accounting_type === 'lessons_per_month') {
        const currentCount = lesson.instances_count_this_month || 0;
        if (currentCount >= lesson.lessons_per_month) {
          return `This month's lesson limit has been exceeded (${currentCount}/${lesson.lessons_per_month})`;
        }
      }
      
      return 'Add new lesson';
    }
  }
}
</script>

<template>
  <div>
    <h1>{{btyp=='b2b' ? "B2B Corporate Students": "B2C Individual Students" }}</h1>


    <div class="d-flex justify-content-end " style="position:absolute; top:5px; right:0; height:30px;" v-if="admin">
      <button type="button" class="btn btn-primary" @click="showImportModal" v-if="btyp=='b2b'">
        Import Students
      </button>
      <button type="button" class="btn btn-primary" @click="addVyuka">
       Add Lesson
      </button>
    </div>

    <import-students ref="importStudentsComponent" @import-successful="handleImportSuccess"></import-students>
  </div>

  <div class=" card card-body  mt-2">
    <div class="row">
      <div class="col-md-3" >
        <label>Search Student (email or name)</label>
        <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          @input="handleSearchInput"
          placeholder="Enter student email or name"
        >
      </div>

      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Company</label>
        <select v-model="selectedCompany" class="form-control">
          <option value="">-- Select Company --</option>
          <option v-for="company in companies" :key="company.id" :value="company.id">
            {{ company.name }}
          </option>
        </select>



      </div>

      <div class="col-md-3" v-if="admin">
        <label>Lecturer</label>
        <select v-model="selectedLector" class="form-control">
          <option value="">-- Select Lecturer --</option>
          <option v-for="lector in lector_options" :key="lector.id" :value="lector.id">
            {{ lector.first_name }} {{ lector.last_name }}
          </option>

        </select>

      </div>

      <div class="col-md-3" v-if="!admin">
        <label>Lessons</label>
        <select v-model="zaskok" class="form-control">
          <option value="m">My Lessons</option>
          <option value="all">Enter Substitute</option>
        </select>
      </div>

      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Lesson Type</label>
        <select class="form-control" v-model="selectedTypeLesson">
          <option></option>
          <option value="one_to_one">One-to-One</option>
          <option value="two_students">Pair Lesson</option>
          <option value="group">Group Lesson</option>

        </select>

      </div>

      <div class="col-md-3" >
        <label>Credit</label>
        <select v-model="credit_range" class="form-control">
          <option value="">All</option>
          <option value="less_than_4">Less than 4 lessons</option>
          <option value="more_than_4">More than 4 lessons</option>
          <option value="no_credit">No credit</option>
        </select>
      </div>

      <div class="col-md-3">
        <label>Status</label>
        <select v-model="activeStatus" class="form-control">
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <div class="col-md-2">
        <label>Per page</label>
        <select v-model.number="per" class="form-control">
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>

    </div>

    <!-- New row for Group Name filter -->
    <div class="row mt-2">
      <div class="col-md-3" v-if="btyp==='b2b'">
        <label>Group Name</label>
        <input
          type="text"
          class="form-control"
          v-model="searchGroupName"
          @input="handleGroupNameInput"
          placeholder=""
        />
      </div>
    </div>




    <OjPagination
        class="m-auto"
        :totalItems="total"
        :currentPage="page"
        :perPage="per"
        @pageChanged="pageChanged"
        :key="`pagination-top-${page}`"
    />

    <table class="table table-bordered mt-2">

      <thead>
      <tr>
        <th style="width: 50px; text-align: center;">Status</th>
        <th>Student/s</th>
        <th v-if="btyp === 'b2b'">Group name</th>
        <th v-if="btyp === 'b2b'">Company</th>
        <th>Lecturer</th>
        <th>Types of lessons</th>
        <th>Language</th>
        <th>Language level</th>
        <th>Preferred time</th>
        <th>How many minutes</th>
        <th v-if="btyp === 'b2b'">Lesson number</th>
        <th>Credit</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="lesson in lessons" :key="lesson.id">
        <td class="text-center">
          <span 
            :class="['badge', 'badge-status', lesson.active ? 'badge-success' : 'badge-danger']"
            :title="lesson.active ? 'Active lesson' : 'Inactive lesson'"
          >
            {{ lesson.active ? 'A' : 'N' }}
          </span>
        </td>
        <td>
          <ul class="list-unstyled mb-0">
            <li v-for="student in lesson.students" :key="student.id">
              <template v-if="admin">
               <a :href="`/students/${student.id}`" target="_blank">{{ student.email }}</a>
              </template>
              <template v-else>
                {{ student.email }}
              </template>
            </li>
          </ul>
        </td>
        <td v-if="btyp === 'b2b'">{{ lesson.group_name || '-' }}</td>
        <td v-if="btyp === 'b2b'">{{ lesson.organization?.name || 'N/A' }}</td>
        <td>{{ lesson.lector ? [lesson.lector.first_name, lesson.lector.last_name].join(' ')  : 'N/A' }}</td>
        <td>{{ lesson.lesson_type_name }}</td>
        <td>{{ lesson.language ? lesson.language.iso_code : 'N/A' }}</td>
        <td>{{ lesson.language_level }}</td>
        <td>
          <template v-if="lesson.preferred_time && lesson.preferred_time.length > 0">
            <span 
              v-for="(timeKey, idx) in lesson.preferred_time.split(',')" 
              :key="idx" 
              :class="['badge', 'badge-preferred-time', 'mr-1', 'mb-1', getPreferredTimeBadgeClass(timeKey.trim())]"
            >
              {{ lesson.preferred_time_names && lesson.preferred_time_names[idx] ? lesson.preferred_time_names[idx] : timeKey }}
            </span>
          </template>
          <span v-else class="text-muted">-</span>
        </td>
        <td>{{ lesson.minutes }}</td>
        
        <!-- Lesson number (B2B only) - with accounting badge for flexible/lessons_per_month -->
        <td v-if="btyp === 'b2b'">
          <div v-if="lesson.accounting_type === 'flexible'">
            <span class="badge badge-info badge-sm">
              <i class="fas fa-infinity"></i> Flexible
            </span>
            <div class="mt-1">{{lesson.instances_count}}</div>

          </div>
          <div v-else-if="lesson.accounting_type === 'lessons_per_month'">
            <span class="badge badge-warning badge-sm">
              <i class="fas fa-calendar-check"></i> Monthly Limit
            </span>
            <div class="mt-1">{{ lesson.instances_count_this_month || 0 }} / {{ lesson.lessons_per_month }}</div>
          </div>
          <span v-else class="text-muted">-</span>
        </td>
        
        <!-- Credit - with accounting badge for credit_based (B2B), always show for B2C -->
        <td>
          <template v-if="lesson.accounting_type === 'credit_based' || btyp === 'b2c'">
            <span v-if="btyp === 'b2b'" class="badge badge-success badge-sm">
              <i class="fas fa-coins"></i> Credit
            </span>
            <div :class="{ 'mt-1': btyp === 'b2b' }">
              {{lesson.instances_count}} /
              <a href="#" 
                 @click.prevent="showCreditHistory(lesson)" 
                 class="credit-link"
                 title="Show Credit History">
                {{lesson.credit}}
              </a>
            </div>
          </template>
          <span v-else class="text-muted">-</span>
        </td>

        <!-- Akce -->
        <td>
          <div class="action-buttons">
            <a v-if="admin" href="#" @click.prevent="handleEditLesson(lesson)" class="btn-icon" title="Edit">
              <i class="fas fa-pencil-alt text-primary"></i>
            </a>
            <a v-if="admin" href="#" @click.prevent="handleDeleteLesson(lesson)" class="btn-icon btn-icon-delete" title="Delete">
              <i class="fas fa-trash-alt"></i>
            </a>
            <a href="#" 
               @click.prevent="handleNewLessonInstance(lesson)" 
               class="btn-add-lesson" 
               :class="{ 'disabled': !canAddLessonInstance(lesson) }"
               :title="canAddLessonInstance(lesson) ? 'Add new lesson' : getLimitMessage(lesson)">
              <i class="fas fa-plus"></i> Add new
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <OjPagination
        class="m-auto"
        :totalItems="total"
        :currentPage="page"
        :perPage="per"
        @pageChanged="pageChanged"
        :key="`pagination-bottom-${page}`"
    />
    <p class="text-center">Zobrazeno {{ lessons.length }} z {{ total }} vyfiltrovaných lekcí</p>
  </div>
  <vyuka-form :lesson="current_lesson" :btyp="btyp" :admin="admin" ref="formVyuka" @save-lesson="handleSaveLesson"></vyuka-form>

 <lesson-instance :lesson="current_lesson" ref="formLessonInstance" :admin="admin" :currentuser="currentuser"></lesson-instance>

 <admin-credit-history-modal ref="creditHistoryModal" />

</template>

<style scoped>
.credit-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  transition: all 0.2s ease;
}

.credit-link:hover {
  color: #0056b3;
  background-color: #e7f3ff;
  text-decoration: underline;
}

.badge-sm {
  font-size: 0.7rem;
  padding: 0.2rem 0.45rem;
  display: inline-block;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  white-space: nowrap;
}

.btn-icon {
  font-size: 1.05rem;
  transition: transform 0.2s;
  cursor: pointer;
  text-decoration: none;
}

.btn-icon:hover {
  transform: scale(1.2);
}

.btn-icon-delete {
  color: #dc3545;
}

.btn-icon-delete:hover {
  color: #a71d2a;
}

.btn-add-lesson {
  color: #28a745;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  transition: all 0.2s ease;
}

.btn-add-lesson:hover {
  color: #218838;
  text-decoration: none;
}

.btn-add-lesson i {
  font-size: 0.8rem;
}

/* Disabled styl pro Add new tlačítko */
.btn-add-lesson.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #999;
}

.btn-add-lesson.disabled:hover {
  color: #999;
}

/* Custom purple badge for evening */
.badge-purple {
  background-color: #6f42c1;
  color: white;
}

.badge-preferred-time {
  font-size: 0.75rem;
  padding: 0.3rem 0.6rem;
  font-weight: 600;
  display: inline-block;
}

.badge-status {
  font-weight: bold;
  font-size: 0.9rem;
  min-width: 30px;
  padding: 0.4rem 0.6rem;
  display: inline-block;
  border-radius: 4px;
}
</style>